// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/passenger-briefing-contents.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/passenger-briefing-contents/passenger-briefing-contents.js';

mount([g0]);
